/**
 * Route detection utilities for org-scoped pages (/organizations/:orgSlug/...).
 */

export const isOrgScopedHomePage = (pathname: string): boolean => /^\/organizations\/[^/]+\/?$/.test(pathname);

export const isOrgScopedMyLearningPage = (pathname: string): boolean => pathname.endsWith('/my-learning');

export const isOrgScopedBrowsePage = (pathname: string): boolean => pathname.includes('/browse');

export const isOrgScopedSearchPage = (pathname: string): boolean => pathname.includes('/search');

export const isOrgScopedBrowseOrSearchPage = (pathname: string): boolean =>
  isOrgScopedBrowsePage(pathname) || isOrgScopedSearchPage(pathname);

export const isCareerAcademyPage = (pathname: string): boolean => pathname.startsWith('/career-academy');
